export default "__VITE_ASSET__5c2ada46__"